<app-card class="mb-16" theme="{{ typeCapacite === 'realiste' ? 'turquoise' : 'yellow' }}">
  <div header>
    <h3 class="dsd-t-5 dsd-mb-0" [attr.data-cy]="'titre_' + typeCapacite">
      {{ title }}
    </h3>
  </div>
  <div class="dsd-d-flex">
    <div class="dsd-fg-1">
      <div>
        <div class="dsd-b-30 dsd-mb-0" [attr.data-cy]="'label_prix_achat_' + typeCapacite">
          <span class="dsd-mb-0" [innerHTML]="'capacite.capacity-card.prix-achat' | translate"></span>
          <span class="sr-only">{{ 'capacite.capacity-card.prix-achat-sr-only' | translate }}</span>
        </div>
        <span class="dsd-t-4 dsd-fw-bold dsd-mb-sm" [attr.data-cy]="'valeur_prix_achat_' + typeCapacite">
          {{ valeurPropriete | desjardinsCurrency }}
        </span>
      </div>

      <hr class="dsd-hr mb-8" />

      <div>
        <div class="dsd-b-30 dsd-mb-0" [attr.data-cy]="'label_paiement_hypothecaire_' + typeCapacite">
          <span class="dsd-mb-0" [attr.data-cy]="'label_versement_mensuel_' + typeCapacite">
            {{ 'capacite.capacity-card.paiement-hypothecaire' | translate }}
          </span>
        </div>
        <div class="mb-0-8">
          <app-currency-string
            class="dsd-d-block dsd-fw-bold amount"
            [value]="versementMensuel"
            [periodicity]="'&nbsp;' + ('label-frequences.mensuel' | translate)"
            [id]="'montant-mensuel-' + typeCapacite"
            [attr.data-cy]="'versement_mensuel_' + typeCapacite"
          >
          </app-currency-string>
        </div>
      </div>
    </div>
  </div>
</app-card>
